import { render, staticRenderFns } from "./no-investments-found.component.vue?vue&type=template&id=e9ff2fae"
import script from "./no-investments-found.component.vue?vue&type=script&lang=js"
export * from "./no-investments-found.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports